import { Outlet } from 'react-router-dom';
import SettingsSidebar from './_Components/SettingsSidebarNew';

export default function SettingsLayout() {
  return (
    <div className="flex h-full bg-gray-50 dark:bg-gray-900">
      <SettingsSidebar />
      <div className="flex-1 overflow-y-auto">
        <Outlet />
      </div>
    </div>
  );
}